module.exports = __webpack_public_path__ + "img/feature1.e3258e3f.png";